'use strict';

angular.module('shiftTraderApp')
  .directive('saWorkPeriodLineItem', function ($location, $filter, $state, $q, UserPermissionsService, NotesStore) {
    return {
      templateUrl: 'views/directives/saWorkPeriodLineItem.html',
      restrict: 'EA',
      priority: 100,
      scope: {
        workPeriod: '=saWorkPeriodLineItem',
        getLinkUrl: '=linkFn',
        type: '@',
        hideUser: '=',
        hidePublished: '='
      },
      link: function(scope, elem) {
        scope.$state = $state;

        scope.state = {
          hasNote: false
        };

        if (!scope.type) {
          scope.type = '';
        }

        var promises = [];

        promises.push(UserPermissionsService.getCanDict([
          'notes.view_admin',
          'notes.view_management',
          'notes.view_public',
          'notes.create'
        ], scope.workPeriod.organization.id));

        promises.push(NotesStore.getNotesForObjWithDate('WorkPeriod', scope.workPeriod.id, scope.workPeriod.range_twix));
        promises.push(NotesStore.getNotesForObjWithDate('Position', scope.workPeriod.position_id, scope.workPeriod.range_twix));


        $q.all(promises).then(function(values) {
          var notes = values[1];
          var permissions = values[0];
          var positionNotes = values[2];

          var myPermLevel = (permissions['notes.view_public']) ? 0 : -1;
          myPermLevel = (permissions['notes.view_management']) ? 1 : myPermLevel;
          myPermLevel = (permissions['notes.view_admin']) ? 2 : myPermLevel;

          var notes = lodash.filter(notes, function(note) {
            return note.permission <= myPermLevel;
          });
          var positionNotes = lodash.filter(positionNotes, function(note) {
            return note.permission <= myPermLevel;
          });

          scope.state.noteClasses = {
            'has-shift-note': notes && notes.length > 0,
            'has-position-note': positionNotes && positionNotes.length > 0 && !(notes && notes.length > 0)
          };
        }, function(response) {
          console.log('Failing Promises', response);
        });

        var layoutType = scope.type.toLowerCase();
        elem.find('.work_period_line_item').addClass(layoutType);

        scope.showDepartmentBar = layoutType !== 'thin' && layoutType !== 'thin_with_position';
        scope.showPositionBar = layoutType !== 'thin' && layoutType !== 'thin_with_position';
        scope.showEmployeeBar = layoutType === 'focus' && !scope.hideUser;
        scope.showPublishInfo = layoutType === 'focus' && !scope.hidePublished;
        scope.showDayInfo = layoutType !== 'thin' && layoutType !== 'thin_with_position';

        scope.followLink = function() {
          $location.path(scope.getLinkUrl(scope.workPeriod).slice(2));
        };

        if (layoutType === 'thin') {
          scope.topDateLineContent = $filter('uppercase')(scope.workPeriod.user.first_name);
          scope.bottomDateLineContent = $filter('uppercase')(scope.workPeriod.user.last_name);
        } else if (layoutType === 'thin_with_position') {
          scope.topDateLineContent = $filter('uppercase')(scope.workPeriod.user.first_name) + ' ' + $filter('uppercase')(scope.workPeriod.user.last_name)[0];
          scope.bottomDateLineContent = scope.workPeriod.position.name;
        } else {
          scope.topDateLineContent = $filter('uppercase')(scope.workPeriod.start_time.format('MMM'));
          scope.bottomDateLineContent = $filter('uppercase')(scope.workPeriod.start_time.format('ddd'));
        }

      }
    };
  });
